import type { AppThunk } from 'state';
import FetchingStatus from 'constants/statuses/FetchingStatus';
import { DataServiceStaticRoutes } from 'common/dataService/services';
import { setUpdating, setUpdatingKey } from '../slice';
import { StaticRouteModel } from 'common/dataService/types/staticRouteTypes';
import handleRequestError from 'managers/handleRequestError';

function createStaticRoutes(requestParameters: StaticRouteModel): AppThunk {
  return async function fetchStaticRoutes(dispatch, getState) {
    try {
      const { fetching } = getState().flightDefinitionGroups;

      if (fetching === FetchingStatus.InProgress) {
        return;
      }

      dispatch(setUpdatingKey('create'));

      dispatch(setUpdating(FetchingStatus.InProgress));

      await DataServiceStaticRoutes.createStaticRoute(requestParameters);

      dispatch(setUpdating(FetchingStatus.Succeeded));
    } catch (error) {
      dispatch(handleRequestError(error, 'Error occured on creating static routes!', setUpdating));
    }
  };
}

export default createStaticRoutes;
